import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  appBar: {
    '& button': {
      boxShadow: 'none',
    },
  },
}));
